import { Navigate } from 'react-router-dom';
import { useSelector } from 'store';
import { ReactElement } from 'react';

interface PermissionGuardProps {
  children: ReactElement | null;
  module: string;
}

/**
 * Guards a route by module permission key.
 * Admins always pass. Non-admins are redirected to /profile when permission is explicitly false.
 */
export default function PermissionGuard({ children, module }: PermissionGuardProps) {
  const user = useSelector((state) => state.user);
  const modulePermissions = useSelector((state) => state.userConfig.modulePermissions);

  if (user?.Role === 'admin') return children;
  if (!modulePermissions) return children;
  if (modulePermissions[module] === false) return <Navigate to="/profile" replace />;

  return children;
}
